//não funciona direito passando a string, deve-se modificar algo
// const regex = '/^[0-9]{0,}$/';
export const codeRegex = new RegExp(/^[0-9]{0,}$/);
